import React, { useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import WorkspaceSelector from "../Helper/WorkspaceSelector";
import TokenValidator from "./TokenValidator";
import ExpiredOwner from "../Views/Subscriptions/ExpiredOwner";
import ExpiredUser from "../Views/Subscriptions/ExpiredUser";
import { LoadingCircle } from "../Components/LoadingCircle";
import PeerConnectionManager from "../Services/PeerConnectionManager";
import { getWorkspace } from "../Model/Workspace";
import { workspaceEvents } from "../db/workspaceEvents";

/**
 * Helper Route to Check for Active Subscription
 */
const ProtectedRoute = ({ needRole = false, specificRole = null, needActiveWorkspace = true }) => {
  const navigate = useNavigate();
  const { currentWorkspace } = WorkspaceSelector();
  const { validateToken } = TokenValidator();

  const [workspace, setWorkspace] = useState(null)
  useEffect(() => {
    async function loadWorkspace() {
      const data = await getWorkspace()
      setWorkspace(data)
    }
    loadWorkspace();

    const handleWorkspaceChange = () => {
      loadWorkspace();
    };

    workspaceEvents.addEventListener("workspaceChange", handleWorkspaceChange);

    return () => {
      workspaceEvents.removeEventListener("workspaceChange", handleWorkspaceChange);
    };
  }, [])
  const [accessState, setAccessState] = useState("loading");

  useEffect(() => {
    const checkToken = async () => {
      if (!PeerConnectionManager.isConnected()) {
        await validateToken();
        const checkRole = (role) => {
          return role && specificRole == null
            ? role === "OWNER" || role === "MANAGER" || role === "ADMIN"
            : role === specificRole || role === "ADMIN";
        };

        const rawUserData = localStorage.getItem("user");
        const userData = rawUserData ? JSON.parse(rawUserData) : null;
        const workspaces = userData?.workspace
        const workspaceAccess = workspaces ? workspaces[currentWorkspace()] : null
        const hasWorkspaces = (workspaces && workspaces.length > 0)

        if (!userData) {
          navigate("/app/login")
          return
        }

        if (!workspaceAccess && hasWorkspaces) {
          navigate("/app");
          return;
        }

        let ws = workspace
        if(!ws){
          ws = await getWorkspace()
        }

        if (hasWorkspaces && !ws.subscriptionActive && needActiveWorkspace) {
          if (workspaceAccess.role === "OWNER") {
            setAccessState("ownerExpired");
          } else {
            setAccessState("userExpired");
          }
          return;
        }

        if (needRole) {
          if (!checkRole(userData.role) && !checkRole(workspaceAccess.role)) {
            navigate("/app");
            return;
          }
        }
      }

      setAccessState("allowed");
    };
    checkToken();
  }, [navigate, currentWorkspace, needRole, specificRole, validateToken, workspace]);

  if (accessState === "loading") return <LoadingCircle />;
  if (accessState === "ownerExpired") return <ExpiredOwner />;
  if (accessState === "userExpired") return <ExpiredUser />;

  return <Outlet />;
};

export default ProtectedRoute;
